"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpInput = void 0;
// { firstName: string; lastName: string; email: string; password: string; phoneNumber?: string }
const typebox_1 = require("@sinclair/typebox");
exports.SignUpInput = typebox_1.Type.Object({
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    email: typebox_1.Type.String({
        format: 'email',
    }),
    password: typebox_1.Type.String(),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=sign-up-transports.js.map